import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(undefined); // undefined = loading, null = unauth

    const refresh = useCallback(async () => {
        if (!getToken()) {
            setUser(null);
            return null;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            setUser(null);
            return null;
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setToken(data.access_token);
        await refresh();
        return data;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch (err) {
            if (process.env.NODE_ENV !== "production") {
                console.warn("Logout request failed (local logout proceeds):", err?.message || err);
            }
        }
        setToken(null);
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, login, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
};

export const useAuth = () => useContext(AuthCtx);
